import React, { useState } from "react";
import { Box, Typography, TextField, Button, IconButton , FormControlLabel, Checkbox, Rating} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import feedbackStyle from "./feedbackStyle";

const Feedback = ({ isOpen, closeFeedback }) => {
    const classes = feedbackStyle();
    const [step, setStep] = useState(1);
    const [feedback, setFeedback] = useState("");

    const [formData, setFormData] = useState({
        aesthetics: 3,
        practicality: 3, // Midpoint on scale
        integration: 3,
        usability: 3,
        improvements: "",
        additionalComments: "",
        email: "",
        firstName: "",
        lastName: "",
        agreeTerms: false,
    });

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async () => {
        try {
            const response = await fetch("https://pakethorizons.ddns.net/api/feedback", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            if (response.ok) {
                alert("✅ Feedback submitted successfully!");
                setFeedback(""); // Clear form
                closeFeedback(); // Close panel
            } else {
                alert("Error submitting feedback: " + result.error);
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Failed to submit feedback. Please try again.");
        }
    };

    return (
        <Box className={`${classes.feedbackPanel} ${isOpen ? classes.open : classes.closed}`}>
            {/* Header */}
            <Box className={classes.panelHeader}>
                <Typography className={classes.feedbackTitle}>Feedback</Typography>
                <IconButton onClick={closeFeedback}>
                    <CloseIcon />
                </IconButton>
            </Box>


           {/* Step 1: Sliders */}
           {step === 1 && (
                <Box className={classes.feedbackContent}>
                    <Typography className={classes.feedbackText}>We appreciate your feedback! It helps us improve.</Typography>
                    <hr className={classes.dashedLine} />

                    {[
                        { field: "aesthetics", label: "How visually and functionally appealing is the design?" },
                        { field: "practicality", label: "How does the design fit Munich’s landscape?" },
                        { field: "integration", label: "How user-friendly is our Web App?" },
                        { field: "usability", label: "How overally rate the Web app and design?" },
                    ].map((item, index) => (
                        <div key={item.field} className={classes.ratingRow}>
                            <Typography className={classes.feedbackText}>{index + 1}. {item.label}</Typography>
                            <Rating
                                name={item.field}
                                value={formData[item.field]}
                                onChange={(event, newValue) => handleChange(item.field, newValue)}
                                size="large"
                            />
                        </div>
                    ))}

                    {/* Next Button */}
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={() => setStep(2)}
                        className={classes.button}
                    >
                        Next
                    </Button>
                </Box>
            )}

            {/* Step 2: Comments & User Details */}
            {step === 2 && (
                <Box className={classes.feedbackContent}>
                    <Typography variant="body1">Additional comments</Typography>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        variant="outlined"
                        className={classes.textField}
                        value={formData.additionalComments}
                        onChange={(e) => handleChange("additionalComments", e.target.value)}
                    />

                    <Typography variant="body1">Your Details</Typography>
                    <Box className={classes.nameFieldsContainer}>
                        <TextField
                            fullWidth
                            label="First Name"
                            variant="outlined"
                            className={classes.textField + " " + classes.nameField}
                            value={formData.firstName}
                            onChange={(e) => handleChange("firstName", e.target.value)}
                            style={{ marginBottom: "8px" }}
                        />
                        <TextField
                            fullWidth
                            label="Last Name"
                            variant="outlined"
                            className={classes.textField + " " + classes.nameField}
                            value={formData.lastName}
                            onChange={(e) => handleChange("lastName", e.target.value)}
                            style={{ marginBottom: "8px" }}
                        />
                    </Box>
                    <TextField
                        fullWidth
                        label="Email Address"
                        variant="outlined"
                        type="email"
                        className={classes.textField}
                        value={formData.email}
                        onChange={(e) => handleChange("email", e.target.value)}
                    />

                    {/* Consent Checkbox */}
                    <FormControlLabel
                        className={classes.checkboxContainer}
                        control={
                            <Checkbox checked={formData.agreeTerms}
                            onChange={(e) => handleChange("agreeTerms", e.target.checked)}
                            />}
                        label="I agree to allow Paketpost Horizons to store and process my personal data."
                    />

                    {/* Back & Submit Buttons */}
                    <Box className={classes.buttonContainer}>
                        <Button
                            variant="contained"
                            onClick={() => setStep(1)}
                            className={`${classes.halfButton} ${classes.button}`}
                        >
                            Back
                        </Button>

                        <Button
                            variant="contained"
                            onClick={handleSubmit}
                            className={`${classes.halfButton} ${classes.subButton}`}
                        >
                            Submit
                        </Button>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default Feedback;